import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { ResetPasswordResponse } from '../../shared/types/ResetPasswordDto';
import { OeAppService } from '../../shared/oe-app.service';
import { PasswordSetupType } from '../../shared/types/PasswordSetupType';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PasswordValidation } from '../../shared/form-validations/password-validation';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WindowService } from '../../shared/window.service';

@Component({
  selector: 'lp2-password-setup-box',
  templateUrl: './password-setup-box.component.html',
  styleUrls: ['./password-setup-box.component.scss'],
})
export class PasswordSetupBoxComponent implements OnInit {
  public PasswordSetupType = PasswordSetupType;
  isLoading: boolean;
  email: string;
  name: string;
  resetSuccess: boolean;
  setupType: PasswordSetupType;
  setupForm: FormGroup;
  token: string;

  @ViewChild('errorModalTemplate') errorModalTemplate: ElementRef;

  constructor(
    private loginService: LoginService,
    private oeAppService: OeAppService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private windowService: WindowService
  ) {
    this.email = this.oeAppService.getData('person').email;
    this.name = this.oeAppService.getData('person').firstName;

    this.setupForm = fb.group(
      {
        password: new FormControl('', [
          Validators.required,
          PasswordValidation.PasswordRestriction(this.email, this.name),
        ]),
        confirmPassword: '',
      },
      {
        validator: PasswordValidation.MatchPassword,
      }
    );

    this.setupType = this.oeAppService.getData('passwordSetupType');
  }

  ngOnInit() {
    const urlParams = new URLSearchParams(window.location.search);
    this.token = urlParams.get('token');
  }

  setupPassword() {
    this.isLoading = true;
    const model = this.setupForm.value;
    this.loginService.setupPassword(model.password, model.confirmPassword, this.token).subscribe(
      (res) => {
        this.isLoading = false;
        if (res.response === ResetPasswordResponse.OK) {
          this.windowService.redirectToUrl('/j_spring_security_logout');
          return;
        }
        this.showErrorModal();
        return;
      },
      (err) => {
        console.error(err);
        this.isLoading = false;
        this.showErrorModal();
      }
    );
  }

  showErrorModal() {
    this.modalService.open(this.errorModalTemplate, {
      backdrop: 'static',
      windowClass: 'password-setup-error',
    });
  }

  get password() {
    return this.setupForm.get('password');
  }
  set password(value) {
    this.setupForm.setValue({ password: value });
  }
  get confirmPassword() {
    return this.setupForm.get('confirmPassword');
  }
  set confirmPassword(value) {
    this.setupForm.setValue({ confirmPassword: value });
  }
}



// WEBPACK FOOTER //
// ./ts/app/login/password-setup-box/password-setup-box.component.ts